import { useTranslation } from 'react-i18next';

import { useCurrentUser } from '@bonusly/who-am-i';

import { useEvaluation } from '../context';

export const useFeedbackCard = () => {
	const evaluation = useEvaluation();
	const { t } = useTranslation('feedback');
	const user = useCurrentUser();

	const name = evaluation.receiver.name;
	let context = 'standard';

	if (evaluation.isPending()) {
		if (evaluation.giverIs(user.id)) {
			context = 'pending_giver';
		} else if (evaluation.receiverIs(user.id)) {
			context = 'pending_receiver';
		}
	}

	return {
		isEditable: evaluation.isOwnedBy(user.id) && !evaluation.isExpired(),
		placeholder: t('message.input_placeholder', {
			context,
			name,
			defaultValue: '',
		}),
	};
};
